import { render } from "./Chunk.vue?vue&type=template&id=ac05e234&scoped=true"
import script from "./Chunk.vue?vue&type=script&lang=js"
export * from "./Chunk.vue?vue&type=script&lang=js"

import "./Chunk.vue?vue&type=style&index=0&id=ac05e234&lang=css"
import "./Chunk.vue?vue&type=style&index=1&id=ac05e234&scoped=true&lang=css"

import exportComponent from "/Users/lianyue/Project/vue-upload-component/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac05e234"]])

export default __exports__